import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, REQ_HEADERS } from "../../consts/api";
import { composeApiUrl } from "../../utilities/api";
import { LOCAL_STORAGE_KEYS } from "../../consts/localStorage";

var requestSchema = yup.object({
  ids: yup.array().of(yup.number()).required(),
  patientId: yup.number().required(),
});

var responseSchema = yup.object({
  objectUrl: yup.string().required(),
});

export function usePatientDocumentsDownloadMutation(options = {}) {
  return useMutation(async (dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    const zipResponse = await fetch(
      composeApiUrl(HTTP_ENDPOINTS.patientDocuments.bulkDownload()),
      {
        method: "POST",
        body: JSON.stringify({
          document_ids: req.ids,
          patient_id: req.patientId,
        }),
        headers: {
          "content-type": "application/json",
          [REQ_HEADERS.accessToken]: localStorage.getItem(
            LOCAL_STORAGE_KEYS.accessToken,
          ),
        },
      },
    );

    const blobZip = await zipResponse.blob();

    return responseSchema.validateSync(
      {
        objectUrl: URL.createObjectURL(blobZip),
      },
      { strict: true },
    );
  }, options);
}
